<template>
  <div>
    <toolbar></toolbar>
    <v-content>
      <v-container grid-list-xl>
        <v-layout row fill-height>
          <v-flex>                       
            <displaybots/>            
          </v-flex>
        </v-layout>  
      </v-container>
    </v-content>
  </div>
</template>

<script>
import toolbar from '../components/Toolbar.vue'
import displaybots from '../components/Display-dashboard.vue'


import {db} from '@/plugins/firebase.js';

  export default { 
    components:{
      toolbar,
      displaybots
    },
    created(){

    },   
    data: () => ({
      
    }),
    methods:{

    }
  }
</script>

<style>

</style>
